import { render, staticRenderFns } from "./SwissQrCode.vue?vue&type=template&id=fd6363f2&v-html=svgElement"
import script from "./SwissQrCode.vue?vue&type=script&lang=js"
export * from "./SwissQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports